import {
  ArchiveTransport,
  chunkedLogsTransport,
} from "@gearbox-protocol/sdk/permissionless";
import { http, Transport } from "viem";

import { chains } from "./chains";

export type TransportConfig = (rpcUrl: string) => Transport;

export const getChainTransport = (
  chainId: number,
  rpcUrl: string,
  hyperSyncToken?: string,
): Transport => {
  const getHyperRpcUrl = (chainId: number) => {
    return `https://${chainId}.rpc.hypersync.xyz/${hyperSyncToken ?? ""}`;
  };

  if (chainId === chains.etherlink.id) {
    return new ArchiveTransport({
      primaryRpcUrl: rpcUrl,
      archiveRpcUrl: "https://explorer.etherlink.com/api/eth-rpc",
      blockThreshold: 499,
      enableLogging: true,
    }).getTransport();
  }

  if (chainId === chains.hemi.id) {
    return new ArchiveTransport({
      primaryRpcUrl: rpcUrl,
      archiveRpcUrl: "https://explorer.hemi.xyz/api/eth-rpc",
      blockThreshold: 999,
      enableLogging: true,
    }).getTransport();
  }

  // Hyperliquid
  if (chainId === 999) {
    return new ArchiveTransport({
      primaryRpcUrl: rpcUrl,
      archiveRpcUrl: "https://www.hyperscan.com/api/eth-rpc",
      blockThreshold: 999,
      enableLogging: true,
    }).getTransport();
  }

  // Ink
  if (chainId === chains.ink.id) {
    return new ArchiveTransport({
      primaryRpcUrl: rpcUrl,
      archiveRpcUrl: hyperSyncToken
        ? getHyperRpcUrl(chainId)
        : "https://explorer.inkonchain.com/api/eth-rpc",
      blockThreshold: 999,
      enableLogging: true,
    }).getTransport();
  }

  if (
    chainId === chains.worldchain.id ||
    chainId === chains.optimism.id ||
    chainId === chains.avalanche.id ||
    chainId === chains.lisk.id ||
    chainId === chains.berachain.id
  ) {
    return new ArchiveTransport({
      primaryRpcUrl: rpcUrl,
      archiveRpcUrl: getHyperRpcUrl(chainId),
      blockThreshold: 999,
      enableLogging: true,
    }).getTransport();
  }

  // Monad
  if (chainId === 143) {
    const primaryTransport = chunkedLogsTransport({
      transport: http(rpcUrl, {
        batch: true,
      }),
      chunkSize: 100,
      enableLogging: true,
    });
    return new ArchiveTransport({
      primaryTransport,
      archiveRpcUrl:
        "https://permissionless-staging.gearbox.foundation/api/thirdweb/rpc/143",
      blockThreshold: 199,
      enableLogging: true,
    }).getTransport();
  }

  // Somnia
  if (chainId === 5031) {
    return new ArchiveTransport({
      primaryRpcUrl: rpcUrl,
      archiveRpcUrl: "https://explorer.somnia.network/api/eth-rpc",
      blockThreshold: 999,
      enableLogging: true,
    }).getTransport();
  }

  // Default
  return http(rpcUrl, {
    retryCount: 3,
    retryDelay: 1000,
    timeout: 10000,
  });
};
